function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13zm-1.456-4.77h2.893v-9.98h-2.893v9.982zm-.287-14.567c0 1.11.632 1.762 1.743 1.762 1.093 0 1.744-.651 1.744-1.762 0-1.112-.651-1.744-1.744-1.744-1.11 0-1.743.632-1.743 1.744z",
  fill: "currentColor"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjYgMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyAyNmM3LjE4IDAgMTMtNS44MiAxMy0xM1MyMC4xOCAwIDEzIDAgMCA1LjgyIDAgMTNzNS44MiAxMyAxMyAxM3ptLTEuNDU2LTQuNzdoMi44OTNWMTEuMjVoLTIuODkzdjkuOTgyem0tLjI4Ny0xNC41NjdjMCAxLjExLjYzMiAxLjc2MiAxLjc0MyAxLjc2MiAxLjA5MyAwIDEuNzQ0LS42NTEgMS43NDQtMS43NjIgMC0xLjExMi0uNjUxLTEuNzQ0LTEuNzQ0LTEuNzQ0LTEuMTEgMC0xLjc0My42MzItMS43NDMgMS43NDR6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { SvgInfo as ReactComponent };